import { useQuery } from "@apollo/client";
import Player from "../../components/player";
import "./players.scss";
import { getAllPlayers } from "../../api/queries";
import useModal from "../../hooks/useModal";
import AddPlayerModal from "../../components/addPlayerModal";

function Players() {
    const { loading, error, data } = useQuery(getAllPlayers);
    const { isShowing, toggle } = useModal();


    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error :(</p>;

    return (
        <div className="players-container">
            <div className="header">
                <h1>All Players</h1>
            </div>
            <button onClick={toggle}>Add a player</button>
            <AddPlayerModal isShowing={isShowing} hide={toggle}/>

            <div className="players-list">
                <ul>
                    <div className="flex-row">
                        <h3 className="player-title">Player</h3>
                        <h3 className="player-stat">PPG</h3>
                        <h3 className="player-stat">RPG</h3>
                        <h3 className="player-stat">APG</h3>
                    </div>
                    {
                        data.getPlayers.map(player => (
                            <li key={player.id}>
                                <Player player={player}></Player>
                            </li>
                        ))
                    }
                </ul>
            </div>
        </div>
    )
}

export default Players;